var _ellipse, _path, _path2, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightGrayAvatar = function SvgLightGrayAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 50 49"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 24.238,
    fill: "#E4E7EC",
    rx: 25,
    ry: 23.988
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D4DAE1",
    fillRule: "evenodd",
    d: "m14.283 36.077 14.589 11.84c9.274-1.394 16.854-7.584 19.838-15.941L29.194 13.25 16.533 36.077z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M27.823 24.47c1.612-1.547 2.741-4.1 2.741-6.345 0-3.482-1.29-6.268-5.645-6.268s-5.645 2.786-5.645 6.268c0 2.244 1.13 4.875 2.742 6.345-3.468.774-6.841 3.405-8.051 10.06-.403 2.09 1.613 2.09 1.613 2.09H34.26c.08 0 2.016 0 1.612-2.09-1.128-6.655-4.583-9.286-8.05-10.06",
    clipRule: "evenodd"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.583,
    cy: 18.64,
    fill: "#fff",
    rx: 7.083,
    ry: 6.797
  })));
};
export { SvgLightGrayAvatar as ReactComponent };
export default __webpack_public_path__ + "fonts/light-gray-avatar-1c636dad626310f4efc488a37e875abb.svg";